
import Navigation from '../../../components/feature/Navigation';
import Footer from '../../../components/feature/Footer';
import AreaHero from '../components/AreaHero';
import AreaServices from '../components/AreaServices';
import AreaTestimonials from '../components/AreaTestimonials';
import AreaCTA from '../components/AreaCTA';
import { useSEO, generateAreaPageSchema, generateBreadcrumbSchema } from '../../../utils/seo';

export default function BusheyPage() {
  const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

  useSEO({
    title: 'Painters & Decorators Bushey Hertfordshire | Brushour',
    description: 'Professional painting and decorating services in Bushey, Hertfordshire. Covering Bushey Village, Bushey Heath, and Oxhey. Fully insured, 18+ years experience. Free quotes – call 07595037441.',
    keywords: 'painters Bushey, decorators Bushey Hertfordshire, painting services Bushey Heath, Bushey painters decorators, decorating Oxhey',
    canonical: `${SITE_URL}/areas/bushey`,
    schema: [
      generateAreaPageSchema('Bushey', 'Hertfordshire', 'bushey', 51.6453, -0.3568, 'WD23'),
      generateBreadcrumbSchema([
        { name: 'Home', url: SITE_URL },
        { name: 'Areas', url: `${SITE_URL}/areas` },
        { name: 'Bushey', url: `${SITE_URL}/areas/bushey` },
      ]),
    ],
  });

  const areaData = {
    name: 'Bushey',
    region: 'Hertfordshire',
    description: 'Professional painting and decorating services in Bushey. We offer comprehensive painting solutions including interior decoration, exterior painting, and specialist finishes for properties across Bushey and the surrounding areas.',
    heroImage: 'https://public.readdy.ai/ai/img_res/c1c90f3b08c7234db8d4b8e5116e5863.jpg',
    serviceAreas: ['Bushey Village', 'Bushey Heath', 'Oxhey', 'Caldecote Hill'],
  };

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <AreaHero data={areaData} />
      <AreaServices area="Bushey" />
      <AreaTestimonials area="Bushey" />
      <AreaCTA area="Bushey" />
      <Footer />
    </div>
  );
}
